// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__2zxE4","Label":"BuildControl__Label__1B309","Less":"BuildControl__Less__2nqWI","More":"BuildControl__More__188r7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuidControls/BuildControl/BuildControl.css
// module id = 64
// module chunks = 0